import { IsiPresentationLogic } from "./IsiPresentationLogic";
import { IsiDtoPlCheckDateFormatRequest, IsiDtoPlCheckDateFormatResponse } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlCheckDateFormat";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";

export class IsiPlCheckDateFormat extends IsiPresentationLogic {

    constructor() {
        super("IsiPlCheckDateFormatHandler");
    }

    /**
     * Vérifie le format d'une date saisie
     * @param value
     * @param format
     * @returns
     */
    public async checkDateFormat(value: string, format: string) {

        const params = IsiDtoPlCheckDateFormatRequest.fromJS({
            value: value,
            format: format,
            response: IsiDtoPlCheckDateFormatResponse.fromJS({})
        });

        const result: IIsiUIFlowResultGeneric<IsiDtoPlCheckDateFormatRequest> = await this.ajaxWithErrorHandling("CheckDateFormat", params, true);
        return result.reponse.response.validFormat;
    }
}